import httpClient from '../utils/httpClient';
import { API_ENDPOINTS } from '../config/api';

export const authService = {
  // Sign in user
  async signIn(credentials) {
    const response = await httpClient.post(API_ENDPOINTS.AUTH.SIGNIN, {
      usernameOrEmail: credentials.usernameOrEmail,
      password: credentials.password,
      keepLoggedIn: credentials.keepLoggedIn || false
    });

    if (response.token) {
      // Store token and user info
      sessionStorage.setItem('authToken', response.token);
      sessionStorage.setItem('userInfo', JSON.stringify({
        username: response.username,
        email: response.email,
        roles: response.roles
      }));
    }

    return response;
  },

  // Sign up user
  async signUp(userData) {
    const response = await httpClient.post(API_ENDPOINTS.AUTH.SIGNUP, {
      username: userData.username,
      email: userData.email,
      password: userData.password,
      confirmPassword: userData.confirmPassword
    });

    if (response.token) {
      // Store token and user info
      sessionStorage.setItem('authToken', response.token);
      sessionStorage.setItem('userInfo', JSON.stringify({
        username: response.username,
        email: response.email,
        roles: response.roles
      }));
    }

    return response;
  },

  // Sign out user
  signOut() {
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('userInfo');
  },

  // Get current user info
  getCurrentUser() {
    const userInfo = sessionStorage.getItem('userInfo');
    return userInfo ? JSON.parse(userInfo) : null;
  },

  // Check if user is authenticated
  isAuthenticated() {
    return !!sessionStorage.getItem('authToken');
  },

  // Get auth token
  getToken() {
    return sessionStorage.getItem('authToken');
  },

  // Google OAuth redirect
  initiateGoogleOAuth() {
    window.location.href = API_ENDPOINTS.AUTH.GOOGLE_OAUTH;
  }
};

export default authService;